var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 234,
    viewBox: "0 0 240 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 -1.16568e-05H197.5C203.083 -0.00527336 208.612 1.09043 213.77 3.22439C218.929 5.35835 223.616 8.48868 227.564 12.4362C231.511 16.3838 234.642 21.071 236.776 26.2297C238.91 31.3884 240.005 36.9173 240 42.5V191.5C240.005 197.083 238.91 202.612 236.776 207.77C234.642 212.929 231.511 217.616 227.564 221.564C223.616 225.511 218.929 228.642 213.77 230.776C208.612 232.91 203.083 234.005 197.5 234H42.5C36.9174 234.005 31.3885 232.91 26.2297 230.776C21.071 228.642 16.3838 225.511 12.4362 221.564C8.48871 217.616 5.35838 212.929 3.22442 207.77C1.09046 202.612 -0.00524284 197.083 1.88608e-05 191.5V42.5C-0.00524284 36.9173 1.09046 31.3884 3.22442 26.2297C5.35838 21.071 8.48871 16.3838 12.4362 12.4362C16.3838 8.48868 21.071 5.35835 26.2297 3.22439C31.3885 1.09043 36.9174 -0.00527336 42.5 -1.16568e-05Z",
    fill: "#000B1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 192C108.807 192 120 180.807 120 167V142H95C81.1929 142 70 153.193 70 167C70 180.807 81.1929 192 95 192Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 117C70 103.193 81.1929 92 95 92H120V142H95C81.1929 142 70 130.807 70 117Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 67C70 53.1929 81.1929 42 95 42H120V92H95C81.1929 92 70 80.8071 70 67Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 42H145C158.807 42 170 53.1929 170 67C170 80.8071 158.807 92 145 92H120V42Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 117C170 130.807 158.807 142 145 142C131.193 142 120 130.807 120 117C120 103.193 131.193 92 145 92C158.807 92 170 103.193 170 117Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 234,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.e0c1cdcf46a54b0d2b48133fc304ec4e.svg";
export { ForwardRef as ReactComponent };